import { render, staticRenderFns } from "./ContentRelevance.vue?vue&type=template&id=59e3bd50"
import script from "./ContentRelevance.vue?vue&type=script&lang=js"
export * from "./ContentRelevance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports